export enum OperationsActivity {
  Note = 1,
  Attachment = 2,
}
